module.exports = {
  server: "PLG",
  serverTokenUrl: "",
  serverUrl: "https://services.plg1.cwsuite.com/retail/graphql",
  CWCoreServicesUrl: "https://services.plg1.cwsuite.com/core/graphql",
  edcUrl: "http://localhost:80/innoweb/api/MSwipe",
  innovitiPaymentCodes: {
    Card: 0,
    GPay: 86,
    Sodexo: 90,
    UPI: 86,
  },
  fileDownloadUrl: 'https://services.plg1.cwsuite.com:8444/'
};